export const METRIC_TYPOGRAPHY_SETTINGS = {
  color: true,
  bold: true,
  italic: true,
  fontSize: true,
};

export const PRIMARY_VALUE_FONT_SIZES = [30, 35, 40, 45, 50, 55, 60];
export const SECONDARY_VALUE_FONT_SIZES = [12, 13, 14, 15, 16, 17, 18];
